import React from 'react';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, ModalFooter, ModalBody, ModalHeader, Button, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import * as actions from '../../actions/Grant'
import { getOptions } from '../../utils';
import moment from 'moment';

class AddGrant extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchText: '',
            grantName: null,
            grantNumber: null,
            grantType: null,
            grantManager: null,
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
        };
    }

    handleAdd = () => {
        const grantToSend = {
            name: this.state.grantName,
            number: this.state.grantNumber,
            grantType: this.state.grantType,
            grantManager: this.state.grantManager,
            isActive: true,
            endDate: moment(this.state.endDate),
            startDate: moment(this.state.startDate),
            sessionId: this.props.sessionId,
            grantId: undefined
        }
        const grantMap = Map(grantToSend)
        this.props.actions.updateGrant(grantMap, this.props.programId)
        this.props.toggle()
    }

    textChange = (e) => {
        this.setState({
            searchText: e.target.value
        }, () => {
            this.props.onSearch(this.state.searchText)
        })
    }

    cancelClick = () => {
        this.setState({ searchText: '' })
        this.props.toggle()
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({[name]: value})
        this.props.actions.setField(this.props.currentSessionId, name, value);
    }

    toggle = () => {
        this.setState({
            searchText: '',
            grantManager: null,
            grantName: null,
            grantNumber: null,
            grantType: null,
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
        });
        this.props.toggle();
    }

    handleGrantStartDateChange = (e) => {
        const { value } = e.target;
        this.setState({ startDate: value })
        this.props.actions.setField(this.props.currentSessionId, 'startDate', value);
    }

    handleGrantEndDateChange = (e) => {
        const { value } = e.target;
        this.setState({ endDate: value })
        this.props.actions.setField(this.props.currentSessionId, 'endDate', value);
    }
    render() {
        return (
            <Modal
                scrollable={true}
                isOpen={this.props.isOpen}
                toggle={this.toggle}
                size='lg'
            >
                <ModalHeader toggle={this.toggle}>Add Grant</ModalHeader>
                <ModalBody>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Name:</Label>
                                <Input name='grantName' onChange={(e) => this.setState({ grantName: e.target.value })} required value={this.state.grantName} />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label>Number:</Label>
                                <Input name='grantNumber' onChange={(e) => this.setState({ grantNumber: e.target.value })} value={this.state.grantNumber} />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label>Grant Type:</Label>
                                    <Input
                                        type='select'
                                        name='grantType'
                                        value={this.state.grantType || ''}
                                        onChange={this.handleChange}
                                    >
                                    {getOptions(this.props.grantTypes, true)}
                                </Input>
                            </FormGroup>
                            </Col>
                    </Row>
                    <Row>
                    <Col>
                         <FormGroup>
                             <Label>BJA Grant Manager:</Label>
                                <Input name='grantManager' onChange={(e) => this.setState({ grantManager: e.target.value })} value={this.state.grantManager} />
                         </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>Start Date:</Label>
                                <Input type='date' name='startDate' onChange={(e) => this.handleGrantStartDateChange(e)} value={moment(this.state.startDate).format('YYYY-MM-DD')} />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>End Date:</Label>
                                <Input type='date' name='endDate' onChange={(e) => this.handleGrantEndDateChange(e)} value={moment(this.state.endDate).format('YYYY-MM-DD')} />
                        </FormGroup>
                    </Col>
                </Row>
                <ModalFooter>
                    <Button color="primary" disabled={!this.state.grantName} onClick={this.handleAdd}>Add</Button>{' '}
                    <Button color="secondary" onClick={this.cancelClick}>Cancel</Button>
                   </ModalFooter>
                </ModalBody>
            </Modal>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions }, dispatch) }
}

export default connect(null, mapDispatchToProps)(AddGrant);
